import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useUniversalLoginRedirect } from "@bto/shared";
import { Button } from "../../components/shared/Button/Button";
import { SpinnerLoading } from "../../components/shared/Spinner/SpinnerLoading";
import { isProviderUniversalLoginConfigured } from "../../auth/providerUniversalLogin";
import { AUTH_CALLBACK_URL } from "../../utils/urlConstants";
import {
  ProviderAuthActions,
  ProviderAuthShell,
  ProviderAuthSpinnerWrapper,
} from "../../auth/ProviderAuthShell";

const UniversalLogin = (): React.ReactElement => {
  const history = useHistory();
  const isConfigured = isProviderUniversalLoginConfigured();
  const {
    errorMessage,
    isAuthenticated,
    isLoading,
    screenState,
    redirectToUniversalLogin,
  } = useUniversalLoginRedirect({
    callbackPath: AUTH_CALLBACK_URL,
    isConfigured,
  });

  useEffect(() => {
    if (isLoading || !isAuthenticated) {
      return;
    }

    history.replace(AUTH_CALLBACK_URL);
  }, [history, isAuthenticated, isLoading]);

  return (
    <ProviderAuthShell
      description={screenState === "redirecting" ? undefined : errorMessage}
      isError={screenState === "error"}
      title={screenState === "redirecting" ? undefined : "Unable to sign in"}
    >
      {screenState === "redirecting" ? (
        <ProviderAuthSpinnerWrapper>
          <SpinnerLoading />
        </ProviderAuthSpinnerWrapper>
      ) : (
        <ProviderAuthActions>
          {isConfigured && (
            <Button
              label="Try sign in again"
              onClick={() => redirectToUniversalLogin()}
              size="medium"
              textColor="white"
            />
          )}
        </ProviderAuthActions>
      )}
    </ProviderAuthShell>
  );
};

export default UniversalLogin;
